import Vue from '@triotech/vue-core/src/vendor/vue';
import TestMixin from '@/mixins/test';

const Demo = new Vue({
  mixins: [
    TestMixin,
  ],
  computed: {
    type4QV: () => '4QV',
    type2Qx2Q: () => '2Qx2Q',
    typeHotSpot: () => 'HotSpot',
    type2Q: () => '2Q',
    typeMap() {
      return {
        1: this.type4QV,
        2: this.type2Qx2Q,
        3: this.typeHotSpot,
        4: this.type2Q,
        6: this.type4QV,
        7: this.type2Qx2Q,
        8: this.typeHotSpot,
        9: this.type2Q,
      };
    },
  },
  methods: {
    setup() {
      Vue.set(Vue.prototype, '$test', this);
    },
    getInitTest() {
      return new Promise(this.$nextTick);
    },
    getAdvertising() {
      return this.$ajax.get('public/demo12/advertising').then(ads => this._.transform(ads, (result, ad) => {
        ad.image = {
          upload_file_path: ad.image,
        };
        result.push(ad);
        return result;
      }));
    },
    getImages() {
      return true;
    },
    startTest() {
      return new Promise((resolve) => {
        this.setData({ time: Number(new Date()) });
        resolve();
      });
    },
    getQuestion() {
      return new Promise((resolve) => {
        const testInformation = this.data.test_information;
        const now = Number(new Date());
        testInformation.time_left -= (now - this.data.time) / 1000;
        this.setData({
          test_information: testInformation,
          time: now,
        });
        const question = this.getDemo12Question(false);
        if (!question) {
          resolve({ finished: true });
        } else {
          resolve(this.formatDemo12Question(question));
        }
      });
    },
    postTest(action, answer) {
      return new Promise((resolve) => {
        const question = this.validateDemo12Answer(this._.first(answer.answer));

        if (action === 'postpone') {
          const { questions } = this.data;
          this.data.questions.push(question);
          this.setData({ questions });
        }

        const nextQuestion = this.getDemo12Question();
        if (!nextQuestion) {
          resolve({ finished: true });
        } else {
          const testInformation = this.data.test_information;
          if (action === 'validate' || action === 'noAnswer') {
            testInformation.validated += 1;
          } else if (action === 'postpone') {
            testInformation.postponed[question.id_test] = true;
          }
          testInformation.question_number = nextQuestion.ordre;

          this.setData({ test_information: testInformation });
          resolve(this.formatDemo12Question(nextQuestion));
        }
      });
    },
    getTimeOut() {
      return new Promise(this.$nextTick);
    },
    finishedTest() {
      return new Promise((resolve) => {
        const testInformation = this.data.test_information;

        this._.merge(testInformation.resultDifficulty, this._.transform(this.data.questions, (result, question) => {
          if (this._.isUndefined(testInformation.resultDifficulty[question.niveau])) {
            result[question.niveau] = {
              label: String(question.niveau),
              total: 1,
              valid: 0,
            };
          }
          return result;
        }, {}));

        this._.merge(testInformation.resultSyllabus, this._.transform(this.data.questions, (result, question) => {
          if (this._.isUndefined(testInformation.resultSyllabus[question.itemsyl])) {
            result[question.itemsyl] = {
              label: String(question.txt_catsyl),
              total: 1,
              valid: 0,
            };
          }
          return result;
        }, {}));

        resolve({
          nbCorrectAnswers: testInformation.corrects,
          nbQuestions: testInformation.total,
          score: Math.round(testInformation.corrects * 100 / testInformation.total),
          resultSyllabus: testInformation.resultSyllabus,
          resultDifficulty: testInformation.resultDifficulty,
        });
      });
    },
    quitTest() {
      return new Promise(this.$nextTick).then(() => {
        this.$router.push({ name: 'result' });
      });
    },
    setDemo12(data) {
      this.setData({
        label: data.lbl_name,
        language: data.langue,
        image: {
          upload_file_path: data.image,
        },
        syllabus_localised_name: data.name,
        questions: data.questions,
        question_index: 0,
        test_images: this._.transform(data.questions, (result, question) => {
          const { image } = question;
          if (image) {
            result[question.id_question] = { upload_file_path: image };
          }
          return result;
        }, {}),
        total_time: data.t_max * 60,
        test_information: {
          total: data.NbQMax,
          validated: 0,
          postponed: {},
          question_number: 1,
          time_left: data.t_max * 60,
          corrects: 0,
          resultSyllabus: {},
          resultDifficulty: {},
        },
      });
    },
    getDemo12Question(next = true) {
      let questionIndex = this.data.question_index;
      if (next) {
        questionIndex += 1;
        this.setData({ question_index: questionIndex });
      }
      return this.data.questions[questionIndex];
    },
    getDemo12QuestionKind(question) {
      return this.typeMap[question.typeQ];
    },
    isDemo12AnswerValid(answer) {
      const question = this.getDemo12Question(false);
      const kind = this.getDemo12QuestionKind(question);

      if (this._.isPlainObject(answer) && kind === this.typeHotSpot) {
        return this._.reduce(this._.reduce(question, (carry, value, key) => {
          if (key.indexOf('HS') === 0 && value !== '0') {
            carry.push(this._.zipObject(['x', 'y', 'width', 'height'], value.split(' ').map(Number)));
          }
          return carry;
        }, []), (carry, hotSpot) => {
          const xValid = answer.x >= hotSpot.x && answer.x <= (hotSpot.x + hotSpot.width);
          const yValid = answer.y >= hotSpot.y && answer.y <= (hotSpot.y + hotSpot.height);
          return (xValid && yValid) || carry;
        }, false);
      }

      return String(answer) === question.repOK;
    },
    getDemo12SubSyallbusId(question) {
      return question.sscatsyl.split('.').slice(0, 2).join('.');
    },
    formatDemo12Question(question) {
      const kind = this.getDemo12QuestionKind(question);
      const answers = kind === this.typeHotSpot ? null : [];
      if (this._.isArray(answers)) {
        answers.push({ id: 1, value: question.rep1 }, { id: 2, value: question.rep2 });
        if (kind === this.type4QV || kind === this.type2Qx2Q) {
          answers.push({ id: 3, value: question.rep3 }, { id: 4, value: question.rep4 });
        }
      }
      const image = this.data.test_images[question.id_question];
      const testInformation = this.data.test_information;
      return {
        test_information: this._.extend(testInformation, {
          nb_postpone: this._.toArray(testInformation.postponed).length,
          percent: testInformation.validated / testInformation.total * 100,
        }),
        question: {
          id: question.id_question,
          label: question.question,
          question_difficulty: {
            label: String(question.niveau),
          },
          explaination: question.explic !== '0' ? question.explic : '',
          kind,
          answers,
          image,
        },
        module_localised_label: `${this.getDemo12SubSyallbusId(question)} ${question.txt_catsyl}`,
      };
    },
    validateDemo12Answer(answer) {
      const question = this.getDemo12Question(false);
      const testInformation = this.data.test_information;
      const valid = this.isDemo12AnswerValid(answer);
      const syllabusId = this.getDemo12SubSyallbusId(question);
      const levelId = String(question.niveau);

      if (!testInformation.resultSyllabus[syllabusId]) {
        testInformation.resultSyllabus[syllabusId] = {
          label: question.txt_catsyl,
          total: 0,
          valid: 0,
        };
      }

      if (!testInformation.resultDifficulty[levelId]) {
        testInformation.resultDifficulty[levelId] = {
          label: levelId,
          total: 0,
          valid: 0,
        };
      }

      testInformation.resultSyllabus[syllabusId].total += 1;
      testInformation.resultDifficulty[levelId].total += 1;

      if (valid) {
        testInformation.corrects += 1;
        testInformation.resultSyllabus[syllabusId].valid += 1;
        testInformation.resultDifficulty[levelId].valid += 1;
      }

      this.setData({ test_information: testInformation });
      return question;
    },
  },
});

Vue.set(Vue.prototype, '$demo', Demo);

export default Demo;
